<template>
    <div class="mx-auto col-lg-4 col-md-6 col-sm-12 header-margin">
        <div class="text-center p-2">
            <h4>{{ $t('hec.saving.settingTitle') }}</h4>
        </div>

        <form @submit.prevent="handleOnSubmit" class="text-center">  
            <div class="box">
                <div class="wrap">
                    <div class="condition"> 
                        <!-- Forthing送金設定 -->
                        <div class="setting-box flex">
                            <div> 
                                <label class="setting-title" v-html="$t('hec.saving.forthingSettingTitle')"></label>
                            </div>
                            <div class="colon">:</div>
                            <div class="left">
                                <!-- OFF -->
                                <span v-if="disabled_flg">
                                    <span v-if="Number(formData.forthing_setting) === 0">
                                        <input type="radio" name="forthing_setting" id="forthing_off" value=0 v-model="formData.forthing_setting">
                                    </span>
                                    <span v-else>
                                        <input type="radio" name="forthing_setting" id="forthing_off" value=0 v-model="formData.forthing_setting" disabled>     
                                    </span>
                                </span>
                                <span v-else>
                                    <input type="radio" name="forthing_setting" id="forthing_off" value=0 v-model="formData.forthing_setting">
                                </span>
                                <label class="value-title value-space" for="forthing_off">{{ $t('hec.saving.offLabel') }}</label>
                                
                                <!-- 2年 -->
                                <span v-if="disabled_flg">
                                    <span v-if="Number(formData.forthing_setting) === 2">
                                        <input type="radio" name="forthing_setting" id="forthing_two"value=2 v-model="formData.forthing_setting">
                                    </span>
                                    <span v-else>
                                        <input type="radio" name="forthing_setting" id="forthing_two"value=2 v-model="formData.forthing_setting" disabled>
                                    </span>
                                </span>
                                <span v-else>
                                     <input type="radio" name="forthing_setting" id="forthing_two"value=2 v-model="formData.forthing_setting">
                                </span>
                                <label class="value-title" for="forthing_two">{{ $t('hec.saving.twoYearsLabel') }}</label>                  
                            </div>
                        </div>
                    </div>
                </div> 
            </div>

            <div class="box">
                <div class="wrap">
                    <div class="condition"> 
                        <!-- EX BONUS送金設定 -->
                        <div class="setting-box flex">
                            <div> 
                                <label class="setting-title" v-html="$t('hec.saving.exBonusSettingTitle')"></label>
                            </div>
                            <div class="colon">:</div>
                            <div class="left">
                                <!-- OFF -->
                                <span v-if="disabled_flg">
                                    <span v-if="Number(formData.ex_bonus_setting) === 0">
                                        <input type="radio" name="ex_bonus_setting" id="exbonus_off" value=0 v-model="formData.ex_bonus_setting">
                                    </span>
                                    <span v-else>
                                        <input type="radio" name="ex_bonus_setting" id="exbonus_off" value=0 v-model="formData.ex_bonus_setting" disabled>
                                    </span>
                                </span>
                                <span v-else>
                                    <input type="radio" name="ex_bonus_setting" id="exbonus_off" value=0 v-model="formData.ex_bonus_setting">
                                </span>
                                <label class="value-title value-space" for="exbonus_off">{{ $t('hec.saving.offLabel') }}</label>
                                <!-- 2年 -->
                                <span v-if="disabled_flg">
                                    <span v-if="Number(formData.ex_bonus_setting) === 2">
                                        <input type="radio" name="ex_bonus_setting" id="exbonus_two" value=2 v-model="formData.ex_bonus_setting">
                                    </span>
                                    <span v-else>
                                        <input type="radio" name="ex_bonus_setting" id="exbonus_two" value=2 v-model="formData.ex_bonus_setting" disabled>
                                    </span>
                                </span>
                                <span v-else>
                                    <input type="radio" name="ex_bonus_setting" id="exbonus_two" value=2 v-model="formData.ex_bonus_setting">
                                </span>
                                <label class="value-title" for="exbonus_two">{{ $t('hec.saving.twoYearsLabel') }}</label>
                            </div>
                        </div>
                    </div>
                </div> 
            </div>

            <div v-if="!campaign_flag">
                <div class="text-center">
                    <div class="pb-4 ">
                        <button type="submit" class="btn btn-primary">{{ $t('hec.saving.btnConfirmText') }}</button>
                    </div>
                </div>
            </div>
        </form>
    </div>
</template>

<script>
    import UserService from '../../services/UserService'
    import HecService from '../../services/HecSavingService'
    import { HEC_SAVING_OFF_VALUE, HEC_SAVING_TWO_YEARS_VALUE, FORTHING_CAMPAIGN_TERM_SECOND } from '../../utils/Const'

    export default {
        name: 'automatic-remittance',

        data() {
            return {
                formData: this.getDefaultFields(),
                campaign_flag: false,
                disabled_flg: false,
            }
        },

        async mounted() {
        },

        created() {
            this.fetchUserData();
            
        },
        methods: {
            getDefaultFields() {
                return {
                    forthing_setting: 0,
                    ex_bonus_setting: 0,
                };
            },

            async handleOnSubmit() {
                this.errors = this.getDefaultFields();
                try {
                    sessionStorage.formData = JSON.stringify(this.formData)
                    this.$router.push('/hec-saving/automatic-remittance-confirm');
                } catch (err) {
                    if (err.response.data.errors) {
                        err.response.data.errors.forEach(errItem => {
                            if (errItem.field) {
                                this.errors[errItem.field] = errItem.message[0];
                            }
                        })
                    }
                }
            },
            async fetchUserData() {
                try {
                    if (sessionStorage.formData) {
                        // sessionStorageに入力データが存在する場合入力データをデフォルト値に
                        this.selectData = JSON.parse(sessionStorage.formData);
                        this.formData.forthing_setting = this.selectData.forthing_setting;
                        this.formData.ex_bonus_setting = this.selectData.ex_bonus_setting;
                    } else {
                        // sessionStorageに入力データが存在しない場合
                        // 既存データの存在チェック
                        const history_data = (await HecService.getReserveHecSavingSettingHistory()).data;

                        if (history_data.forthing === null || history_data.exbonus === null) {
                            // sessionStorageに入力データが存在せず、既存データも存在しない
                            this.formData.forthing_setting = HEC_SAVING_OFF_VALUE;
                            this.formData.ex_bonus_setting = HEC_SAVING_OFF_VALUE;
                        } else {
                            // 既存データが存在する場合は既存データをデフォルト値に
                            if (Number(history_data.forthing.plan) === HEC_SAVING_OFF_VALUE || Number(history_data.forthing.plan) === HEC_SAVING_TWO_YEARS_VALUE) {
                                this.formData.forthing_setting = history_data.forthing.plan;
                            } else {
                                // 不正な値の場合はデフォルト0を設定
                                this.formData.forthing_setting = HEC_SAVING_OFF_VALUE;        
                            }
                            
                            if (Number(history_data.exbonus.plan) === HEC_SAVING_OFF_VALUE || Number(history_data.exbonus.plan) === HEC_SAVING_TWO_YEARS_VALUE) {
                                this.formData.ex_bonus_setting = history_data.exbonus.plan;
                            } else {
                                this.formData.ex_bonus_setting = HEC_SAVING_OFF_VALUE;
                            }
                        }
                    }

                    const data = (await UserService.getUserFrontendData()).data;
                    
                    // キャンペーン時期情報を取得し、確認ボタンの表示・非表示判定を追加
                    if (data.latestMembershipFee) {
                        if (data.latestMembershipFee.forthing_campaign_term === FORTHING_CAMPAIGN_TERM_SECOND) {
                            this.campaign_flag = true;
                            this.disabled_flg = true;
                        } else {
                            this.campaign_flag = false;
                        }
                    } else {
                        this.campaign_flag = false;
                    }
                } catch (e) {
                    this.$router.push('/');
                }
            },
        }
    }
</script>

<style scoped>
    .form-group {
        margin-top: 20px;
        margin-bottom: 20px;
    }
    .setting-box{
        text-align:center;
        margin-top: 20px;
        margin-bottom: 20px; 
    }
    .setting-title{
        width: 160px;
        text-align: right;
    }
    .radio-box{
        vertical-align: middle;
    }
    .value-title{
        margin-bottom: 2px;
    }
    .value-space{
        margin-right: 5px;
    }
    .setting-radio{
        margin-left: 2px;
        margin-right: 2px;
        text-align:left;
    }
    .btn-primary {
        width: 115px;
        margin-top: 10px;
    }
    .btn-primary:hover {
        color: #fff !important;
        background-color: #350f71 !important;
        border-color: #300e66 !important;
    }

    .flex{
        display: flex;
    }
    .colon{
        width: 20px;
    }
    .left{
        width: calc(100% - 200px);
        text-align: left;
        width: 140px;
    }
    .box {
        text-align:left;
        border-top-width: 0px;
    }
    .wrap {
        margin-left: auto;
    }
    .condition {
        width: 100%;
        display: flex;
        max-width: 332px;
        margin: 0 auto;
    }

    @media (min-width: 992px){
        .col-lg-4 {
            flex: 0 0 50%;
            max-width: 50%;
        }
    }
    @media (min-width: 768px){
        .col-md-6 {
            flex: 0 0 50%;
            max-width: 50%;
        }
    }
    @media (min-width: 576px){
        .col-sm-12 {
            flex: 0 0 50%;
            max-width: 50%;
        }
    }
</style>
